/**
 * Copyright 2020-present, TIENDUC.
 * All rights reserved.
 * @author ductt24@ghtk.com on 11/08/2020.
 * @module APP SELECTORS
 */

import { get } from "lodash";

const selectAppDomain = state => state.app;

// Dữ liệu kho
const REPOSITORY = "repositories";
// Danh sách tỉnh thành
const PROVINCES = "provinces";

export const makeSelectRepository = state =>
  get(selectAppDomain(state), REPOSITORY, []);

export const makeSelectProvinces = state =>
  get(selectAppDomain(state), PROVINCES, {});
export const makeSelectListProvince = state =>
  get(selectAppDomain(state), "listProvince", []);
export const makeSelectStation = state =>
  get(selectAppDomain(state), "listStation", []);
export const makeSelectStationRaw = state =>
  get(selectAppDomain(state), "listStationRaw", []);
export const makeSelectPrinterType = state =>
  get(selectAppDomain(state), "printerType", []);
export const makeSelectPrinterStatus = state =>
  get(selectAppDomain(state), "printerStatus", []);
export const makeSelectListUser = state =>
  get(selectAppDomain(state), "listUser", []);
export const makeSelectListMenu = state =>
  get(selectAppDomain(state), "listMenu", []);
export const makeSelectListStrictedRoute = state =>
  get(selectAppDomain(state), "listStrictedRoute", []);

export const makeSelectAppByPath = (state, path = []) => get(state.app, path);
